import {createSelector} from 'reselect';

import {getUIState} from '../ui-selectors';

const getLimitUIState = createSelector([getUIState], (uiState) => uiState.limits);

export const getLimitsModalType = createSelector(
    [getLimitUIState],
    (limitsState) => limitsState.type
);

export const getIsAllLimitsModalOpen = createSelector(
    [getLimitUIState],
    (limitsState) => limitsState.isAllLimitsModalOpen
);

export const getShouldLinkToBilling = createSelector(
    [getLimitUIState],
    (limitsState) => limitsState.allLimitsModalShouldLinkToBilling
);

export const getTitleText = createSelector(
    [getLimitUIState],
    (limitsState) => limitsState.allLimitsModalTitleText
);
